// export const API_URL = "https://dlhfzt6p2j.execute-api.ap-south-1.amazonaws.com/qa";
// export const API_TOKEN = "dirfJGZkvH5skKzFs9iYiadtsbuMdPBtanJ1m0JV";
export const API_URL = process.env.REACT_APP_API_URL || "fallback-url";
export const API_TOKEN = process.env.REACT_APP_API_TOKEN || "fallback-token";
